var _defs, _g, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifiAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .wifi-alert-cls-1 {\n        fill: currentColor;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "wifi-alert-cls-1",
    d: "M13.81,20.86c.09.69.36,1.33.79,1.85-.45.25-.88.57-1.26.95-.39.39-1.02.39-1.41,0-.39-.39-.39-1.03,0-1.42.57-.57,1.2-1.03,1.88-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wifi-alert-cls-1",
    d: "M23.07,23.66c-.19.19-.45.29-.7.29s-.52-.1-.71-.29c-.37-.37-.78-.69-1.22-.93.42-.52.71-1.15.79-1.85.66.35,1.28.8,1.84,1.36.39.39.39,1.03,0,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wifi-alert-cls-1",
    d: "M7.06,17.38c1.89-1.89,4.2-3.2,6.72-3.86v2.08c-1.98.6-3.79,1.68-5.3,3.19-.39.39-1.02.39-1.42,0-.39-.39-.39-1.02,0-1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wifi-alert-cls-1",
    d: "M27.94,18.79c-.2.2-.45.29-.71.29s-.51-.09-.71-.29c-1.49-1.49-3.29-2.57-5.25-3.17v-2.08c2.5.65,4.79,1.96,6.67,3.84.39.39.39,1.02,0,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wifi-alert-cls-1",
    d: "M32.86,13.92c-.2.2-.46.3-.71.3s-.51-.1-.71-.29c-3.31-3.29-7.5-5.17-11.81-5.62-1.4-.15-2.8-.16-4.2-.01-4.32.45-8.53,2.33-11.82,5.63-.39.39-1.02.39-1.41,0-.39-.4-.39-1.03,0-1.42,8.43-8.42,22.18-8.43,30.65,0,.39.39.4,1.02.01,1.41Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "wifi-alert-cls-1",
    cx: 17.53,
    cy: 27.12,
    r: 2.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wifi-alert-cls-1",
    d: "M19.77,20.38c0,1.24-1,2.25-2.24,2.25s-2.24-1.01-2.24-2.25v-8.99c0-1.24,1-2.25,2.24-2.25s2.24,1.01,2.24,2.25v8.99Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiAlert);
export default __webpack_public_path__ + "static/media/wifi_alert.3fc18fe816cc07fc7c1173b33e75f7e5.svg";
export { ForwardRef as ReactComponent };